import React from 'react'
import { useDraggable } from '@dnd-kit/core'
import { CSS } from '@dnd-kit/utilities'
import { GripVertical } from 'lucide-react'
import { cn } from '@/lib/utils'

export interface Position {
  x: number
  y: number
}

interface DraggableTextProps {
  id: string
  children: React.ReactNode
  position: Position
  className?: string
  isEditable?: boolean
}

export const DraggableText: React.FC<DraggableTextProps> = ({
  id,
  children,
  position,
  className,
  isEditable = true,
}) => {
  const { attributes, listeners, setNodeRef, transform, isDragging } =
    useDraggable({
      id,
    })

  const style = {
    transform: CSS.Transform.toString(transform),
    left: `${position.x}px`,
    top: `${position.y}px`,
  }

  if (!isEditable) {
    return (
      <div className={cn('absolute', className)} style={style}>
        {children}
      </div>
    )
  }

  return (
    <div
      ref={setNodeRef}
      className={cn(
        'absolute group',
        isDragging ? 'cursor-grabbing z-50' : 'cursor-grab z-20',
        className
      )}
      style={style}
      {...attributes}
      {...listeners}
    >
      <div className="relative">
        <GripVertical className="absolute -left-6 top-1/2 -translate-y-1/2 w-4 h-4 text-white opacity-0 group-hover:opacity-100 transition-opacity" />
        {children}
      </div>
    </div>
  )
}
